import { showToast } from '../utils/toast.js';

export function initUiUtils() {
    // Logic Tính toán trực tiếp trên ô nhập tiền
    const amountInputs = [
        document.getElementById('txn-amount'),
        document.getElementById('txn-transfer-amount')
    ];
    
    amountInputs.forEach(amountInput => {
        if(!amountInput) return;

        // Sự kiện khi bấm ra ngoài (blur) -> Thực hiện tính toán và Format dấu phẩy
        amountInput.addEventListener('blur', () => {
            let val = amountInput.value.trim();
            if (!val) return;

            try {
                // Lọc bỏ dấu phẩy cũ và các ký tự chữ cái (chỉ giữ số và toán tử + - * /)
                let sanitized = val.replace(/,/g, '').replace(/[^-()\d/*+.]/g, '');
                if (!sanitized) return;

                // Xử lý tính toán chuỗi
                let result = eval(sanitized);
                
                // Làm tròn số và Format dạng 50,000
                result = Math.round(result);
                amountInput.value = result.toLocaleString('en-US');
                
            } catch (e) {
                amountInput.classList.add('border-expense', 'text-expense');
                setTimeout(() => amountInput.classList.remove('border-expense', 'text-expense'), 1000);
                showToast('Invalid calculation!', 'error');
            }
        });

        // Sự kiện khi bấm lại vào ô để sửa -> Tạm thời xóa dấu phẩy đi để gõ tiếp cho dễ
        amountInput.addEventListener('focus', () => {
            amountInput.value = amountInput.value.replace(/,/g, '');
        });
    });
}
